module.exports = __webpack_public_path__ + "static/media/go-read-logo.bedf8d77.svg";